module.exports = __webpack_public_path__ + "static/media/brush.14b7a98b.svg";